import { UploadDetailsPanels } from '@/features/uploads/components/UploadDetailsPanels';
import { DetailPageTemplate, DetailTitlePrefix } from '@/ui/composites/scaffolds';
import { Section } from '@/ui/layout/Section';
import { Stack } from '@/ui/layout/Stack';
import { Surface, Text } from '@/ui/primitives';
import type { BuildDto, UploadDto } from '@flowqa/shared';
import type { ReactElement } from 'react';

type UploadDetailContentProps = {
  title: string;
  upload: UploadDto;
  build: BuildDto | null;
};

export const UploadDetailContent = ({
  title,
  upload,
  build,
}: UploadDetailContentProps): ReactElement => (
  <DetailPageTemplate
    title={
      <Text role="sectionTitle" component="h1">
        <DetailTitlePrefix label="Upload" />
        {title}
      </Text>
    }
    metadata={<UploadDetailsPanels upload={upload} build={build} />}
    primaryContent={
      upload.error || upload.errorSummary ? (
        <Section paddingY="md">
          <Surface padding="lg" border>
            <Stack gap="sm">
              <Text role="sectionTitle">Error Details</Text>
              {upload.errorSummary ? (
                <Text role="body" color="textSecondary">
                  {upload.errorSummary}
                </Text>
              ) : null}
              {upload.error ? (
                <Text role="body" color="textSecondary">
                  {upload.error}
                </Text>
              ) : null}
            </Stack>
          </Surface>
        </Section>
      ) : null
    }
  />
);
